import { RequestDTO } from './Request';
import { Nullable } from '@core/helpers';
import type { NullablePrimaryDocumentation } from '@outkeep/shared';

export enum RequestDealDetailsInstallingEnv {
  Outdoor = 1,
  Indoor = 2,
}

export type RequestDealDetails = {
  id: number;
  requestId: RequestDTO['id'];
  installerTime: string;
  releaseTime: Exclude<RequestDTO['releaseTime'], undefined>;
  subjTime: string;
  releaseStartTime: string;
  completedTime: string;
  durationInHours: string;
  durationInMinutes: number;
  installingEnv: RequestDealDetailsInstallingEnv;
  thirdParties: boolean;
  documentsGiven: boolean;
  keysGiven: boolean;
  nothingGiven: boolean;
  problems: string;
  createdAt: Date;
  createdId: number;
  updatedAt: Date;
  demountedDevicesCount: Nullable<number>;
  primaryDocumentation: NullablePrimaryDocumentation;
};

export type RequestDealDetailsExtended = {
  details?: RequestDealDetails;
  isCurrentUserInstaller: boolean;
};

export type RequestDealDetailsWithInstaller = RequestDealDetails & {
  isCurrentUserInstaller: boolean;
};

export type CreateRequestDealDetailsData = Pick<
  RequestDealDetails,
  | 'installerTime'
  | 'subjTime'
  | 'releaseStartTime'
  | 'completedTime'
  | 'installingEnv'
  | 'documentsGiven'
  | 'keysGiven'
  | 'nothingGiven'
  | 'thirdParties'
  | 'problems'
  | 'demountedDevicesCount'
  | 'primaryDocumentation'
> &
  Partial<Pick<RequestDealDetails, 'durationInMinutes' | 'releaseTime'>>;
